import { render } from "./documents_editor_crop.vue?vue&type=template&id=9841985e"
import script from "./documents_editor_crop.vue?vue&type=script&lang=js"
export * from "./documents_editor_crop.vue?vue&type=script&lang=js"

import exportComponent from "/opt/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__